import React from "react";

const Loader = () => {
    return (

        <div className="showloader">
            <div className="spinner-border text-light" role="status">
                <span className="sr-only"></span>
            </div>
        </div>
    )
}

export default Loader;